import React from 'react';

import { MCButton, MCText, Spinner, TextField, View } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import { remCss } from 'src/helpers';

import ShortInfo from 'src/components/user/ShortInfo';

import { STEPS } from './constants';
import { Virtuoso } from 'react-virtuoso';
import LANG_CONST from 'src/helpers/lang/const';
import { FormRow } from 'components/Form';

const apiStateId = 'savePatient';

export class AddPatient extends BaseComponent {
  get model() {
    return this.props.model;
  }

  get accountModel() {
    return this.props.accountModel;
  }

  get config() {
    return this.props.config;
  }

  componentDidMount() {
    this.model.subscribe(this.subscription);
    this.accountModel.subscribe(this.subscription);
    this.accountModel.on('onLoaded', this.onLoaded);
  }

  componentWillUnmount() {
    this.model.unsubscribe(this.subscription);
    this.accountModel.unsubscribe(this.subscription);
    this.accountModel.cancel('onLoaded', this.onLoaded);
  }

  onLoaded = (items) => {
    if (items[0]) this.accountModel.setState({ patient: items[0] });
  };

  next = async (event) => {
    event.preventDefault();
    this.model.resetApiState(apiStateId);
    const { phoneNumber, patient } = this.accountModel.state;
    const err = this.accountModel.validate('phoneNumber', phoneNumber, apiStateId);

    if (err) return this.accountModel.setInvalidApi(apiStateId, { phoneNumber: err });

    this.accountModel.setStateSilent({
      ...this.accountModel.getEditFields(patient || {})
    });

    if (!patient) {
      this.model.setStateSilent({
        patientId: null
      });
      return this.model.nextStep(STEPS.ADD_PATIENT_DETAIL);
    }

    if (patient.status !== 'inactive' || this.model.state.user?.patientIds?.includes(patient.id)) {
      this.props.loadBeforeSlotStep(patient).then();
    } else {
      this.model.setStateSilent({
        patientId: patient.id
      });
      this.model.nextStep(STEPS.ADD_PATIENT_DETAIL);
    }
  };

  onChange = (n, v) => {
    this.accountModel.resetApiState(apiStateId);
    this.accountModel.handleChange(n, v);
  };

  render = () => {
    const { invalid } = this.accountModel.getApiState(apiStateId);
    const loading =
      this.model.getApiState('getSlots').loading || this.model.getApiState('doctorDetail').loading;

    return (
      <div
        className={
          'mc-tab-content ' + (this.model.state.step === STEPS.ADD_PATIENT ? '' : 'mc-inactive')
        }
      >
        <View style={{ flex: 1, gap: remCss(15) }}>
          <MCText label={LANG_CONST.phone_number} size={20} />
          <FormRow addColspan={1}>
            <TextField
              template={6}
              defaultCountryName={this.model.state.tempCountryAddress}
              name={'phoneNumber'}
              type='phone'
              value={this.accountModel.state.phoneNumber?.toString()}
              onChange={(n, v) => {
                this.onChange(n, v);
                this.onChange('patient', null);
                if (this.accountModel.validate('phoneNumber', v, apiStateId))
                  this.accountModel.handleChangeSearch('');
                else this.accountModel.handleChangeSearch(v || '');
              }}
              invalid={invalid}
            />
          </FormRow>
          <Virtuoso
            style={{ flexGrow: 1, maxWidth: remCss(490) }}
            data={this.accountModel.items()}
            components={{
              Footer: () => (
                <div style={{ textAlign: 'center', padding: '1rem' }}>
                  {this.accountModel.refreshing() && <Spinner />}
                </div>
              )
            }}
            endReached={() => {
              if (this.accountModel.hasMore() && !this.accountModel.refreshing())
                this.accountModel.loadMore();
            }}
            itemContent={(index, item) => {
              const active = item.id === this.accountModel.state.patient?.id;
              return (
                <div
                  className={`mc-flex mc-bb mc-pointer ${active ? 'mc-bg-active' : ''}`}
                  style={{ padding: remCss(12) }}
                >
                  <div className={'mc-grow'} onClick={() => this.onChange('patient', item)}>
                    <ShortInfo user={item} specialist={[]} medium width={48} />
                  </div>
                </div>
              );
            }}
          />
        </View>

        <div className={'mc-flex-20'}>
          <MCButton
            light
            primary
            radius
            medium
            disabled={loading}
            onClick={(e) => {
              e.preventDefault();
              this.model.previousStep();
            }}
            style={{ width: remCss(100) }}
            label={LANG_CONST.buttons.back}
          />
          <div className={'mc-grow'} />
          <MCButton
            primary
            medium
            radius
            light
            style={{ width: remCss(100) }}
            label={LANG_CONST.buttons.cancel}
            disabled={loading}
            onClick={this.props.onBack}
          />
          <MCButton
            primary
            medium
            radius
            dark
            label={LANG_CONST.buttons.next}
            style={{ width: remCss(100) }}
            disabled={this.accountModel.refreshing() || loading}
            loading={loading}
            onClick={this.next}
          />
        </div>
      </div>
    );
  };
}
